import { FC, ReactNode } from 'react';

import { Image } from '../Image';

interface ContainerProps {
  children: ReactNode;
}

export const Container: FC<ContainerProps> = ({ children }) => (
  <div className="my-8 flex justify-center text-center md:my-14">
    <div className="w-full md:max-w-lg lg:max-w-xl">{children}</div>
  </div>
);

interface ImageContainerProps {
  children: ReactNode;
  image: StoryblokImage;
}

export const ImageContainer: FC<ImageContainerProps> = ({
  children,
  image,
}) => (
  <div className="grid-section gap-y-3 md:gap-y-0">
    <div className="col-span-10 col-start-2 flex flex-col justify-center md:col-span-6">
      <div className="mx-auto my-8 max-w-lg">{children}</div>
    </div>
    <div className="col-span-10 col-start-2 md:col-span-6">
      <div className="mx-auto max-w-lg">
        <Image
          alt={image.alt}
          shape="rounded"
          size={{
            sm: { span: 12, ratio: '3/4' },
            md: { span: 6, ratio: '3/4' },
            lg: { span: 4, ratio: '3/4' },
          }}
          src={image.filename}
        />
      </div>
    </div>
  </div>
);
